
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ProformaIncomeService } from '../proforma-income.service';
import { ProformaIncome } from '../proforma-income';

@Component({
    selector: 'app-proforma-income',
    templateUrl: './proforma-income.component.html',
    styleUrls: ['./proforma-income.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ProformaIncomeComponent implements OnInit {

	proformaId: any;
	proformaIdRequired: any;
	proformaList: any;
	metaInfo: any;


	constructor(
		private primengConfig: PrimeNGConfig,
		private proformaIncomeService: ProformaIncomeService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.proformaId = data.proformaId,
			this.proformaIncome = data.proformaIncome,
			this.proformaIncomeId = data.proformaIncome?.proformaIncomeId
			this.statuses = proformaIncomeService.statuses;
	}

	@Input() proformaIncome: ProformaIncome;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() getMetaInfo = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	proformaIncomeId: number;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;
	invalidTargetOccupancyPct = false;
	invalidHighOccupancyPct = false;
	invalidLowOccupancyPct = false;
	invalidHighOccupancyAmt = false;
	invalidLowOccupancyAmt = false;

	validationMessages = {
		'proformaIncomeId': [],
		'seasonName': [{ type: 'required', message: 'Season Name Required' }],
		'seasonStart': [{ type: 'required', message: 'Season Start Required' }],
		'seasonEnd': [{ type: 'required', message: 'Season End Required' }],
		'targetRateAmt': [{ type: 'required', message: 'Season Name Required' }],
		'targetOccupancyPct': [{ type: 'required', message: 'Season Name Required' }],
		'lowAdjPct': [],
		'highAdjPct': [],
		'lowRateAmt': [{ type: 'required', message: 'Low Rate Required' }],
		'hightRateAmt': [{ type: 'required', message: 'High Rate Required' }],
		'proformaId':[] //parent id here
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.fetchProformaIncome();
		this.formBuild();

		// if we were passed the whole proformaIncome object
		if (this.proformaIncome) {
			this.proformaIncomeId = this.proformaIncome.proformaIncomeId;
			this.fixDates();
			this.form1.patchValue(this.proformaIncome);
			// Show validation immediately for existing data so user sees any issues on open
			this.validateRateAmounts();
		}
		this.setDefaultPct();
	}

	setDefaultPct() {
		if(this.form1.value.targetOccupancyPct == undefined || this.form1.value.targetOccupancyPct == null) {
			this.form1.patchValue({ targetOccupancyPct: 0.8 });
		}
		if(this.form1.value.highAdjPct == undefined || this.form1.value.highAdjPct == null) {
			this.form1.patchValue({ highAdjPct: 0.92 });
		}
		if(this.form1.value.lowAdjPct == undefined || this.form1.value.lowAdjPct == null) {
			this.form1.patchValue({ lowAdjPct: 0.63 });
		}
	}

	onTargetChange() {
		//If Low and/or high is empty and target is onChange, populate the low and high with +/- .2 from the target
		// if(this.form1.value.hightRateAmt == undefined || this.form1.value.hightRateAmt == null) {
		if(this.form1.value.targetRateAmt != undefined || this.form1.value.targetRateAmt != null) {
			let hightRateAmt = (this.form1.value.targetRateAmt + (this.form1.value.targetRateAmt * 0.2));
			this.form1.patchValue({ hightRateAmt: Number(hightRateAmt.toFixed()) });
			let lowRateAmt = (this.form1.value.targetRateAmt - (this.form1.value.targetRateAmt * 0.2));
			this.form1.patchValue({ lowRateAmt: Number(lowRateAmt.toFixed()) });
		}
		this.validateRateAmounts();
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.proformaIncomeId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	increasePercentage(percentagefield) {
		let updatedValue = this.form1.value[percentagefield] + 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
	decreasePercentage(percentagefield){
		let updatedValue = this.form1.value[percentagefield] - 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.form1.value.proformaId = this.proformaId;
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			
			if(!this.checkPctValidations()) {
				return;
			}

			this.formLoading = true;
			this.proformaIncomeService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.proformaIncome = res.data.proformaIncome;
						this.proformaIncomeId = this.proformaIncome.proformaIncomeId;
						this.doAdd.emit(this.proformaIncome);
						this.metaInfo = res.meta.Warning;
						this.getMetaInfo.emit(this.metaInfo);
					},
					(err: any) => {
						console.log('proformaIncome-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	// Validates that: High Rate >= Target Rate >= Low Rate
	// Sets invalidHighOccupancyAmt and invalidLowOccupancyAmt flags.
	// Safe to call at any time (init, blur, submit).
	validateRateAmounts() {
		const high = this.form1.value.hightRateAmt;
		const target = this.form1.value.targetRateAmt;
		const low = this.form1.value.lowRateAmt;

		// High rate must be greater than or equal to target rate (and not zero)
		this.invalidHighOccupancyAmt = (
			high != null &&
			(high === 0 || (target != null && high < target) || (low != null && high < low))
		);

		// Low rate must be less than or equal to target rate (and not zero)
		this.invalidLowOccupancyAmt = (
			low != null &&
			(low === 0 || (target != null && low > target) || (high != null && low > high))
		);
	}

	checkPctValidations() {

		if(this.form1.value.targetOccupancyPct != undefined && this.form1.value.targetOccupancyPct == 0) {
			this.invalidTargetOccupancyPct = true;
			return false;
		}
		this.invalidTargetOccupancyPct = false;

		//Higher pecentage can not be zero or lower than target or Low pct
		if(this.form1.value.highAdjPct != undefined &&
			(this.form1.value.highAdjPct == 0 || this.form1.value.highAdjPct < this.form1.value.targetOccupancyPct
				|| this.form1.value.highAdjPct < this.form1.value.lowAdjPct))
		{
			this.invalidHighOccupancyPct = true;
			return false;
		}
		this.invalidHighOccupancyPct = false;

		//Lower pecentage can not be zero or higher than target or High pct
		if(this.form1.value.lowAdjPct != undefined &&
			(this.form1.value.lowAdjPct == 0 || this.form1.value.lowAdjPct > this.form1.value.targetOccupancyPct
				|| this.form1.value.lowAdjPct > this.form1.value.lowAdjPct))
		{
			this.invalidLowOccupancyPct = true;
			return false;
		}
		this.invalidLowOccupancyPct = false;

		// Validate High Rate >= Target Rate >= Low Rate
		this.validateRateAmounts();
		if (this.invalidHighOccupancyAmt || this.invalidLowOccupancyAmt) {
			return false;
		}

		return true;
	}

	formUpdate() {
		console.log('proformaIncome: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			if(!this.checkPctValidations()) {
				return;
			}

			this.formLoading = true;
			this.form1.value.proformaIncomeId = this.proformaIncomeId;
			// this.form1.value.seasonStart = this.addLocalTimeToDateTime(new Date(this.form1.value.seasonStart));
			// this.form1.value.seasonEnd = this.addLocalTimeToDateTime(new Date(this.form1.value.seasonEnd));
			this.proformaIncomeService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.proformaIncome = res.data.proformaIncome;
						this.doUpdate.emit(this.proformaIncome);
						this.metaInfo = res.meta.Warning;
						this.getMetaInfo.emit(this.metaInfo);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.proformaIncomeService.delete(this.proformaIncome.proformaIncomeId)
				.subscribe(
					(res: any) => {
						console.log('proformaIncome-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.proformaIncome);
						this.metaInfo = res.meta.Warning;
						this.getMetaInfo.emit(this.metaInfo);
					},
					(err: any) => {
						console.log('proformaIncome-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			proformaIncomeId: [this.proformaIncomeId],
			seasonName: ['', Validators.required],
			seasonStart: [],
			seasonEnd: [],
			targetRateAmt: [],
			targetOccupancyPct: [],
			lowAdjPct: [],
			highAdjPct: [],
			lowRateAmt: [],
			hightRateAmt: [],
			proformaId:[this.proformaId]
		});
	}

	fixDates() {
	}

	selectProformaIncome(){
		this.proformaIdRequired = false;
	}

	fetchProformaIncome() {
			try {
				this.proformaIncomeService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.proformaList = res.data.proformas;
							return this.proformaList;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime 
	 * @returns 
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
